//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import aos from "~/mixins/aos.js";
import foretell from "~/mixins/foretell.js";
import { clarityEvent } from "~/services/util";

export default {
  layout: "default-no-sticky",
  mixins: [foretell, aos],
  data() {
    return {
      priceTest: " ",
    };
  },
  computed: {
    hasSubscriptionAccess() {
      return this.$store.state.user.data.subscriptionAccess;
    },
    hero() {
      if (this.pageInfo.fields.hero) return this.pageInfo.fields.hero;
    },
    guide() {
      if (this.pageInfo.fields.guide) return this.pageInfo.fields.guide;
    },
    category() {
      return this.$store.state.category.data;
    },
    metaInfo() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.meta_information.table;
    },
    dashboard() {
      let data = {
        headline: "Why choose LegalNature?",
        description:
          "No matter if you are a small business, a large corporation, or an independent landlord, we have you covered.",
      };
      return data;
    },
  },
  head() {
    if (this.pageInfo && this.metaInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain;
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  fetch({ store, params, redirect, req, query, error }) {
    return store
      .dispatch("category/fetch", params.parent_slug)
      .then(() => {
        if (!store.state.category.data) {
          redirect("/categories");
        }
      })
      .catch((e) => {
        console.error(e.message);
        error({ message: "Error fetching data..." });
      });
  },
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "estate-planning-copy", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.log(e);
        error({ message: "Error fetching data..." });
        return {
          loading: false,
          // error: true,
        };
      });
  },

  mounted() {},
};
